import { SocialType } from '~/App/Modules/Socials/util';
import { DisplayOrder } from '~/App/Modules/Testimonials/Pages/Publish/Editor/Containers/Sidebar/Components/Sections/Select';
import { Tag } from './tags';
import { TestimonialResponse } from './testimonial';
import { UserWebAssetContent } from '.';

export enum PublishableType {
  Quote = 'quote',
  Slider = 'slider',
  WallOfLove = 'wall_of_love',
}

export enum PublishableStatus {
  Draft = 'draft',
  Live = 'live',
  Error = 'error',
}

export interface PublishableStyleProps {
  primary_color?: string;
  corner_radius?: number;
  drop_shadow?: boolean;
  border?: boolean;
  border_size?: number;
  border_color?: string;
  font_family?: string;
}

interface PublishableCommonProps {
  uuid: string;
  name: string;
  status: PublishableStatus;
  tag: Tag | null;
  updated_at: string;
  created_at: string;
  is_locked?: boolean;
  publishable_resources?: PublishableResource[];
  metadata?: {
    allow_mobile_tile_restriction?: boolean;
    enable_max_height?: boolean;
    max_height?: number;
    tiles_per_page?: number;
    display_order?: DisplayOrder;
    order?: string[];
    newly_created?: boolean;
    auto_slide?: boolean;
    allow_dynamic_tiles?: boolean;
    hide_name?: boolean;
    hide_title?: boolean;
    hide_profile_image?: boolean;
    hide_date?: boolean;
    hide_carousel_indicator?: boolean;
    hide_carousel_chevron?: boolean;
    style?: PublishableStyleProps;
  };
}

export interface PublishableWallOfLove extends PublishableCommonProps {
  type: PublishableType.WallOfLove;
}

export interface PublishableSlider extends PublishableCommonProps {
  type: PublishableType.Slider;
}

export type Publishable = PublishableSlider | PublishableWallOfLove;

export type ResourceOwner = {
  name: string;
  email: string;
  image: string;
  position?: string;
};

export enum VideoTextAssetTile {
  Video = 'video',
  Text = 'text',
}

export const TileType = { ...VideoTextAssetTile, ...SocialType };
export type TileType = VideoTextAssetTile | SocialType;

export type PublishableTestimonial = {
  owner?: ResourceOwner;
  url?: string;
  type?: TileType | null;
  content?: UserWebAssetContent;
} & Omit<TestimonialResponse, 'type'>;

export type PublishableResource = PublishableTestimonial;
